import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Inventory } from "@mui/icons-material";

const StockChart = ({ stockData, totalProducts }) => {
  const inStock = stockData.find((d) => d.name === "En stock") || { value: 0, percentage: 0 };
  const outStock = stockData.find((d) => d.name === "Sin stock") || { value: 0, percentage: 0 };
  const isEmpty = totalProducts === 0;

  const emptyData = [{ name: "empty", value: 1 }];

  const CenterLabel = ({ viewBox }) => {
    const { cx, cy } = viewBox;
    return (
      <g>
        <text
          x={cx}
          y={cy - 6}
          textAnchor="middle"
          dominantBaseline="central"
          style={{ fontSize: "26px", fontWeight: 800, fill: "#0f172a", letterSpacing: "-0.02em" }}
        >
          {totalProducts}
        </text>
        <text
          x={cx}
          y={cy + 14}
          textAnchor="middle"
          dominantBaseline="central"
          style={{ fontSize: "9px", fontWeight: 600, fill: "#94a3b8", letterSpacing: "1px" }}
        >
          TOTAL
        </text>
      </g>
    );
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "18px",
        border: "1px solid rgba(0,0,0,0.04)",
        padding: "22px 24px",
        backgroundColor: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.02), 0 6px 16px rgba(0,0,0,0.02)",
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#0f172a", mb: 1.5, letterSpacing: "-0.01em" }}>
        Estado del Stock
      </Typography>

      <Box sx={{ flex: 1, display: "flex", alignItems: "center", gap: 4 }}>
        {/* Donut */}
        <Box sx={{ width: 140, height: 140, flexShrink: 0 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={isEmpty ? emptyData : stockData}
                cx="50%"
                cy="50%"
                outerRadius={65}
                innerRadius={45}
                paddingAngle={isEmpty ? 0 : 3}
                dataKey="value"
                startAngle={90}
                endAngle={450}
                cornerRadius={4}
                stroke="none"
              >
                {isEmpty ? (
                  <Cell fill="#f1f5f9" />
                ) : (
                  stockData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={index === 0 ? "#10b981" : "#f43f5e"}
                    />
                  ))
                )}
                <CenterLabel />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Box>

        {/* Stats */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}>
          {/* In stock */}
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#10b981" }} />
                <Typography sx={{ fontSize: "0.72rem", color: "#64748b", fontWeight: 500 }}>En stock</Typography>
              </Box>
              <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#0f172a" }}>
                {inStock.value}
              </Typography>
            </Box>
            <Box sx={{ height: 6, borderRadius: "3px", backgroundColor: "#f1f5f9", overflow: "hidden" }}>
              <Box
                sx={{
                  height: "100%",
                  width: `${isEmpty ? 0 : inStock.percentage}%`,
                  borderRadius: "3px",
                  background: "linear-gradient(90deg, #10b981 0%, #34d399 100%)",
                  transition: "width 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              />
            </Box>
          </Box>

          {/* Out of stock */}
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#f43f5e" }} />
                <Typography sx={{ fontSize: "0.72rem", color: "#64748b", fontWeight: 500 }}>Sin stock</Typography>
              </Box>
              <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#0f172a" }}>
                {outStock.value}
              </Typography>
            </Box>
            <Box sx={{ height: 6, borderRadius: "3px", backgroundColor: "#f1f5f9", overflow: "hidden" }}>
              <Box
                sx={{
                  height: "100%",
                  width: `${isEmpty ? 0 : outStock.percentage}%`,
                  borderRadius: "3px",
                  background: "linear-gradient(90deg, #f43f5e 0%, #fb7185 100%)",
                  transition: "width 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default StockChart;
